import styled from 'styled-components';

export const StyledLine = styled.hr`
    color: ${({ color }) => color};
    background-color: ${({ color }) => color};
    height: ${({ size }) => size};

    width: 100%;
`